// DocumentStatusIcon

export const BYPASSED_ICON_TEST_ID = 'bypassed-icon-test-id';
export const DISCARDED_ICON_TEST_ID = 'discarded-icon-test-id';
export const UPLOADED_ICON_TEST_ID = 'uploaded-icon-test-id';
export const NOT_UPLOADED_ICON_TEST_ID = 'not-uploaded-icon-test-id';
export const APPROVED_ICON_TEST_ID = 'approved-icon-test-id';
export const REJECTED_ICON_TEST_ID = 'rejected-icon-test-id';
export const SIGNATURE_PENDING_ICON_TEST_ID = 'signature-pending-icon-test-id';
export const SIGNATURE_REQUEST_FAILED_ICON_TEST_ID = 'signature-request-failed-icon-test-id';
export const SIGNED_ICON_TEST_ID = 'signed-icon-test-id';
export const INACTIVE_ICON_TEST_ID = 'inactive-icon-test-id';

// Available actions

export const AVAILABLE_ACTIONS_DROPDOWN_TEST_ID = 'available-actions-dropdown-test-id';
export const DOWNLOAD_DOCUMENT_BUTTON_TEST_ID = 'download-document-button-test-id';

// DocumentActionsSection

export const REQUEST_DOCUMENT_BUTTON_TEST_ID = 'request-document-button-test-id';
export const UPLOAD_DOCUMENT_BUTTON_TEST_ID = 'upload-document-button-test-id';

// DocumentCard

export const DOCUMENT_CARD_TEST_ID = 'document-card-test-id';
export const DOWNLOAD_TEMPLATE_BUTTON_TEST_ID = 'download-template-button-test-id';
export const DOCUMENT_CARD_SPINNER_TEST_ID = 'document-card-spinner-test-id';

// DocumentList
export const ACTIVE_DOCUMENTS_LIST_TEST_ID = 'active-document-list-test-id';
export const INACTIVE_DOCUMENTS_LIST_TEST_ID = 'inactive-document-list-test-id';
export const DOCUMENT_LIST_SPINNER_TEST_ID = 'document-list-spinner-test-id';
export const NO_DOCUMENTS_PLACEHOLDER_TEST_ID = 'no-docs-placeholder-test-id';

// RequestSignatureModal

export const REQUEST_SIGNATURE_MODAL_TEST_ID = 'request-signature-modal-test-id';
export const REQUEST_SIGNATURE_EMAIL_TEST_ID = 'request-signature-email-test-id';
export const REQUEST_SIGNATURE_NAME_TEST_ID = 'request-signature-name-test-id';

// UploadDocumentModal

export const UPLOAD_DOCUMENT_MODAL_TEST_ID = 'upload-document-modal-test-id';
export const UPLOAD_DOCUMENT_TYPE_TEST_ID = 'upload-document-type-test-id';
export const UPLOAD_DOCUMENT_NAME_TEST_ID = 'upload-document-name-test-id';
export const UPLOAD_DOCUMENT_FILE_UPLOAD_TEST_ID = 'upload-document-file-upload-test-id';

// RequestDocumentModal

export const REQUEST_DOCUMENT_MODAL_TEST_ID = 'request-document-modal-test-id';
export const REQUEST_DOCUMENT_NAME_TEST_ID = 'request-document-name-test-id';
export const REQUEST_DOCUMENT_DESCRIPTION_TEST_ID = 'request-document-description-test-id';
export const REQUEST_DOCUMENT_FORM_ID = 'request-document-form-id';
export const REQUEST_DOCUMENT_SPINNER_TEST_ID = 'request-document-spinner-test-id';

// StepCompletedBlob

export const STEP_COMPLETED_FILLED_BLOB_TEST_ID = 'step-completed-filled-blob-test-id';
export const STEP_COMPLETED_EMPTY_BLOB_TEST_ID = 'step-completed-empty-blob-test-id';

// EditDocumentModal

export const EDIT_DOCUMENT_MODAL_TEST_ID = 'edit-document-modal-test-id';
export const EDIT_DOCUMENT_NAME_TEST_ID = 'edit-document-name-test-id';
export const EDIT_DOCUMENT_DESCRIPTION_TEST_ID = 'edit-document-description-test-id';

// EditTemplateModal

export const EDIT_TEMPLATE_MODAL_TEST_ID = 'edit-template-modal-test-id';
export const EDIT_TEMPLATE_FORM_ID = 'edit-template-form-test-id';

// WarningModals

export const APPROVE_WARNING_MODAL_TEST_ID = 'approve-warning-modal-test-id';
export const REJECT_WARNING_MODAL_TEST_ID = 'reject-warning-modal-test-id';
export const REMOVE_UPLOAD_WARNING_MODAL_TEST_ID = 'remove-upload-warning-modal-test-id';
export const BYPASS_WARNING_MODAL_TEST_ID = 'bypass-warning-modal-test-id';
export const SEND_SIGN_REMINDER_WARNING_MODAL_TEST_ID = 'send-sign-reminder-warning-modal-test-id';
export const DISCARD_WARNING_MODAL_TEST_ID = 'discard-warning-modal-test-id';

// Add Template Block

export const ADD_TEMPLATE_SECTION_TEST_ID = 'add-template-section-test-id';
export const ADD_TEMPLATE_TOGGLE_BUTTON_TEST_ID = 'add-template-toggle-btn-test-id';
export const ADD_TEMPLATE_RADIO_BUTTON_GROUP_TEST_ID = 'add-template-radio-btn-group-test-id';
export const TEMPLATE_LINK_TEST_ID = 'template-link-test-id';
export const SHOW_LINK_OPTION = 'show-link-option';
export const SHOW_UPLOAD_OPTION = 'show-upload-option';
export const SHOW_LINK_OPTION_TEST_ID = 'show-link-option';
export const SHOW_UPLOAD_OPTION_TEST_ID = 'show-upload-option';
export const UPLOAD_TEMPLATE_TEST_ID = 'upload-template-test-id';
